import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import PropertyContent from '@/propTypes/PropertyContent';
import useGetPackagesCheapestOffer from '../../../../../../hooks/useGetPackagesCheapestOffer';
import getOfferByPropertyId from '../../../../../../utils/getOfferByPropertyId';
import usePreviewProperty from '../../../../hooks/usePreviewProperty';
import Label from './components/Label';
import Price from './components/Price';
import { dataLayer } from '@/v2/utils/dataLayer';
import { useGA4Events } from '@/v2/hooks/featureFlags/ga4Events/useGA4Events';

const Button = styled.button`
  outline: 0;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
`;

const Marker = React.memo(({ property }) => {
  const shouldUseNewEvents = useGA4Events();

  const { previewProperty, setPreviewProperty } = usePreviewProperty();
  const { searchQuery, packagesWithCheapestOffer } =
    useGetPackagesCheapestOffer();

  const byPropertyId = getOfferByPropertyId(packagesWithCheapestOffer);
  const packageOffer = byPropertyId[property.id];

  const isSelected = previewProperty === property;

  return (
    <Button
      data-testid="MARKER_BUTTON"
      onClick={(event) => {
        /**
         * stopPropagation to enable PreviewProperty.ClickOutSide
         */
        event.stopPropagation();
        if (shouldUseNewEvents) {
          dataLayer.mapEvent({
            itemName: property.name,
            groupName: property.destination?.title,
          });
        }
        setPreviewProperty(property);
      }}
    >
      {searchQuery ? (
        <Price isSelected={isSelected} packageOffer={packageOffer} />
      ) : (
        <Label isSelected={isSelected} property={property} />
      )}
    </Button>
  );
});

Marker.propTypes = {
  property: PropTypes.shape(PropertyContent).isRequired,
};

export default Marker;
